"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var fixedBackoff = function (attempt, delay) { return delay; };
var linearBackoff = function (attempt, delay) { return attempt * delay; };
var exponentialBackoff = function (attempt, delay) { return Math.pow(delay, attempt); };
exports.defaultRetryConfig = {
    backoff: "FIXED",
    delay: 100,
    logger: function () { return undefined; },
    maxBackOff: 5 * 60 * 1000,
    retries: 10,
    timeout: 60 * 1000,
    until: function () { return true; },
};
function wait(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
exports.wait = wait;
function retry(f, config) {
    return __awaiter(this, void 0, void 0, function () {
        var cancel;
        return __generator(this, function (_a) {
            config = Object.assign({}, exports.defaultRetryConfig, config);
            switch (config.backoff) {
                case "EXPONENTIAL":
                    config.backoff = exponentialBackoff;
                    break;
                case "FIXED":
                    config.backoff = fixedBackoff;
                    break;
                case "LINEAR":
                    config.backoff = linearBackoff;
                    break;
                default:
            }
            if (config.retries === "INFINITELY") {
                config.retries = Number.MAX_SAFE_INTEGER;
            }
            cancel = exposedPromise();
            return [2 /*return*/, timeout(_retry(f, config, cancel.promise), config.timeout, cancel.resolve)];
        });
    });
}
exports.retry = retry;
// tslint:disable-next-line
function customizeRetry(customConfig) {
    return function (f, c) {
        var customized = Object.assign({}, customConfig, c);
        return retry(f, customized);
    };
}
exports.customizeRetry = customizeRetry;
function _retry(f, config, canceled) {
    return __awaiter(this, void 0, void 0, function () {
        var latestError, stop, delay, i, result, error_1, millisToWait;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stop = false;
                    delay = config.backoff;
                    canceled.then(function () { return stop = true; });
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i <= config.retries && !stop)) return [3 /*break*/, 8];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, f()];
                case 3:
                    result = _a.sent();
                    if (config.until(result)) {
                        return [2 /*return*/, result];
                    }
                    config.logger("Until condition not met by " + result);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    latestError = error_1;
                    config.logger("Retry failed: " + error_1.message);
                    return [3 /*break*/, 5];
                case 5:
                    millisToWait = delay(i + 1, config.delay);
                    return [4 /*yield*/, wait(millisToWait > config.maxBackOff ? config.maxBackOff : millisToWait)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    i++;
                    return [3 /*break*/, 1];
                case 8: throw Error("All retries failed. Last error: " + latestError);
            }
        });
    });
}
exports.notEmpty = function (result) {
    if (util_1.isArray(result)) {
        return result.length > 0;
    }
    return !util_1.isNullOrUndefined(result);
};
function timeout(p, time, onTimeout) {
    return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
            reject(new Error("Timeout after " + time));
            onTimeout();
        }, time);
        return p
            .then(function (result) {
            clearTimeout(timer);
            resolve(result);
        })
            .catch(function (error) {
            clearTimeout(timer);
            reject(error);
        });
    });
}
function exposedPromise() {
    var result = {
        promise: undefined,
        reject: undefined,
        resolve: undefined,
    };
    result.promise = new Promise(function (resolve, reject) {
        result.resolve = resolve;
        result.reject = reject;
    });
    return result;
}
//# sourceMappingURL=retry-promise.js.map